// extracted by mini-css-extract-plugin
export var actions = "_vz-4";
export var item = "_vz-1";
export var price = "_vz-3";
export var quantity = "_vz-2";
export var table = "_vz-0";